import React from 'react';
import { useSectionView, trackCustom } from '../lib/pixel';
const rows = [{
  feature: '6 Tomos clínicos completos',
  a: true,
  b: true,
  c: true
}, {
  feature: '6 Bonos estratégicos',
  a: true,
  b: true,
  c: true
}, {
  feature: 'Sistema de estudio y organización',
  a: false,
  b: true,
  c: true
}, {
  feature: '2 Tomos extra (especialización)',
  a: false,
  b: true,
  c: true
}, {
  feature: '11 Editables premium',
  a: false,
  b: false,
  c: true
}];
const Check = () => <span className="text-green-600 font-black text-base" data-id="element-263">✓</span>;
const Dash = () => <span className="text-gray-300 font-black" data-id="element-264">—</span>;
export function ProBusiness() {
  const sectionRef = useSectionView('Comparison Table');
  return <section ref={sectionRef} className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(220,252,231) 0%, rgb(240,253,244) 50%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-265">
      <div className="mx-auto max-w-2xl" data-id="element-266">
        {/* Header */}
        <div className="text-center mb-6" data-id="element-267">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide text-green-700 border border-green-700/40 bg-green-700/5 rounded-full px-4 py-1.5 mb-3" data-id="element-268">
            📊 Compará los niveles
          </div>
          <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-269">
            ¿Qué incluye <span className="text-green-700" data-id="element-270">cada nivel?</span>
          </h2>
          <p className="text-center text-sm text-gray-500 m-0" data-id="element-271">
            Los tres arrancan con los 6 Tomos y 6 Bonos. Elegí hasta dónde
            querés llegar.
          </p>
        </div>

        {/* Table */}
        <div className="overflow-x-auto rounded-2xl border border-green-700/20 shadow-md mb-6" data-id="element-272">
          <table className="w-full min-w-[420px] bg-white rounded-2xl overflow-hidden text-xs" data-id="element-273">
            <thead data-id="element-274">
              <tr className="border-b-2 border-green-700/10" data-id="element-275">
                <th className="px-4 py-3.5 text-left font-bold text-gray-400 uppercase tracking-wide text-[10px]" data-id="element-276">
                  Incluye
                </th>
                <th className="px-4 py-3.5 text-center font-black text-gray-700 border-l border-gray-100 text-[11px]" data-id="element-277">
                  ✅ Carrera
                  <br data-id="element-278" />
                  Resuelta™
                </th>
                <th className="px-4 py-3.5 text-center font-black text-green-700 border-l border-gray-100 bg-green-50/60 text-[11px]" data-id="element-279">
                  ⭐ Carrera
                  <br data-id="element-280" />
                  Organizada™
                </th>
                <th className="px-4 py-3.5 text-center font-black border-l border-gray-100 text-[11px]" style={{
                background: 'linear-gradient(180deg, rgb(187,247,208) 0%, rgb(220,252,231) 100%)',
                color: 'rgb(21,128,61)'
              }} data-id="element-281">
                  🏆 Biblioteca
                  <br data-id="element-282" />
                  Premium™
                </th>
              </tr>
            </thead>
            <tbody data-id="element-283">
              {rows.map((row, i) => <tr key={row.feature} className={i < rows.length - 1 ? 'border-b border-gray-100' : ''} data-id="element-284">
                  <td className="px-4 py-3 font-semibold text-gray-800" data-id="element-285">
                    {row.feature}
                  </td>
                  <td className="px-4 py-3 text-center border-l border-gray-100 bg-gray-50/50" data-id="element-286">
                    {row.a ? <Check data-id="element-287" /> : <Dash data-id="element-288" />}
                  </td>
                  <td className="px-4 py-3 text-center border-l border-gray-100 bg-green-50/40" data-id="element-289">
                    {row.b ? <Check data-id="element-290" /> : <Dash data-id="element-291" />}
                  </td>
                  <td className="px-4 py-3 text-center border-l border-gray-100" style={{
                backgroundColor: 'rgb(240,253,244)'
              }} data-id="element-292">
                    {row.c ? <Check data-id="element-293" /> : <Dash data-id="element-294" />}
                  </td>
                </tr>)}

              {/* Price row */}
              <tr className="border-t-2 border-green-700/20" data-id="element-295">
                <td className="px-4 py-3.5 text-[11px] font-black text-gray-900 uppercase tracking-wide" data-id="element-296">
                  Precio
                </td>
                <td className="px-4 py-3.5 text-center border-l border-gray-100 bg-gray-50/50" data-id="element-297">
                  <div className="text-[10px] text-gray-400 line-through" data-id="element-298">
                    $58.990
                  </div>
                  <div className="font-black text-gray-900 text-sm" data-id="element-299">
                    $22.950
                  </div>
                </td>
                <td className="px-4 py-3.5 text-center border-l border-gray-100 bg-green-50/40" data-id="element-300">
                  <div className="text-[10px] text-gray-400 line-through" data-id="element-301">
                    $102.990
                  </div>
                  <div className="font-black text-green-700 text-sm" data-id="element-302">
                    $29.950
                  </div>
                </td>
                <td className="px-4 py-3.5 text-center border-l border-gray-100" style={{
                backgroundColor: 'rgb(240,253,244)'
              }} data-id="element-303">
                  <div className="text-[10px] text-gray-400 line-through" data-id="element-304">
                    $149.990
                  </div>
                  <div className="font-black text-sm" style={{
                  color: 'rgb(21,128,61)'
                }} data-id="element-305">
                    $34.950
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-306">
          <a href="#pricing" onClick={() => trackCustom('CTAClick', {
          cta_location: 'pro_business',
          cta_label: 'Elegir Nivel'
        })} className="inline-block text-white text-sm font-black rounded-xl px-8 py-4 no-underline transition-opacity hover:opacity-90" style={{
          background: 'linear-gradient(135deg, rgb(21,128,61), rgb(34,197,94))',
          boxShadow: 'rgba(21,128,61,0.35) 0px 6px 25px 0px'
        }} data-id="element-307">
            → ELEGIR MI NIVEL AHORA
          </a>
          <p className="text-xs text-gray-400 font-medium mt-2 m-0" data-id="element-308">
            Garantía de 7 días · Acceso inmediato · 100% digital
          </p>
        </div>
      </div>
    </section>;
}